import {
	Component,
	ComponentInterface,
	Method,
	Prop,
	Element,
} from '@stencil/core';
import { Video } from '../video-player/video-player.interface';
import { renderVideoInnerContent } from '../../_helpers/video-content';
import { VideoContentAppearance } from '../../../../../_storybook-helpers/video';
import { dsConsole } from '../../_helpers/console';

@Component({
	tag: 'ds-video-content',
})
export class VideoContent implements ComponentInterface {
	@Element() el: HTMLDsVideoContentElement;
	@Prop() appearance: VideoContentAppearance;
	@Prop() messages: string;
	private messagesArray: { [index: string]: string };

	componentDidLoad() {
		try {
			this.messagesArray = JSON.parse(this.messages);
		} catch (error) {
			dsConsole.error(
				'Error in ds-video-content parsing JSON for messages: ',
				this.messages
			);
		}
	}

	@Method()
	async setVideo(video: Video) {
		this.el.innerHTML = renderVideoInnerContent({
			appearance: this.appearance,
			video,
			messages: this.messagesArray,
		});
	}
}
